export const getFareCardBorderStyle = (
  isPrimaryCard: boolean,
): { width: string; color: string } => {
  return {
    width: "1",
    color: isPrimaryCard ? "primary.70" : "neutral.50",
  };
};

const paddingY = { paddingTop: "2px", paddingBottom: "2px" };

export const pillBackground = {
  ED: {
    type: "deals",
    sx: { ...paddingY },
  },
  OP: {
    type: "neutral",
    sx: {
      backgroundColor: "positive.50",
      ...paddingY,
    },
  },
  GO: {
    type: "neutral",
    sx: {
      backgroundColor: "info.50",
      ...paddingY,
    },
  },
  TR: {
    type: "neutral",
    sx: {
      backgroundColor: "secondary.50",
      color: "primary.90",
      ...paddingY,
    },
  },
};

export const neutralColor0Hex = "primary.20";
export const neutralColor90Hex = "neutral.90";

export const getDefaultFareCardPriceStyle = (
  isPrimary: boolean,
): {
  color: string;
  weight: string;
  sx?: React.CSSProperties;
} => {
  return {
    color: isPrimary ? "positive.70" : neutralColor90Hex,
    weight: isPrimary ? "bold" : "normal",
    sx: isPrimary
      ? {
          background: "linear-gradient(135deg, #DA3835 14.13%, #F9700D 85.87%)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }
      : undefined,
  };
};
const nonPrimaryPriceStyle = {
  color: neutralColor90Hex,
  letterSpacing: "0px",
  lineHeight: "22px",
  fontSize: "20px",
};

const primaryPriceStyle = {
  color: neutralColor0Hex,
  letterSpacing: "0px",
  fontSize: "24px",
};

export const getNoButtonFareCardPriceStyle = (
  isPrimary: boolean,
): {
  color: string;
  sx?: object;
} => {
  return {
    color: isPrimary ? neutralColor0Hex : neutralColor90Hex,
    sx: isPrimary
      ? {
          ".money-integer": {
            ...primaryPriceStyle,
          },
          ".money-fraction": {
            ...primaryPriceStyle,
          },
          ".money-currency": {
            ...primaryPriceStyle,
            fontSize: "14px",
          },
          lineHeight: "normal",
        }
      : {
          ".money-integer": {
            ...nonPrimaryPriceStyle,
          },
          ".money-fraction": {
            ...nonPrimaryPriceStyle,
          },
          ".money-currency": {
            ...nonPrimaryPriceStyle,
            fontSize: "14px",
          },
          marginTop: "16px",
        },
  };
};

const whiteLogosFilter = "brightness(0) invert(1)";
export const reColorLogo = {
  OP: {
    sx: {
      img: {
        filter: whiteLogosFilter,
      },
    },
    version: "tiny",
    type: "tiny",
  },
  GO: {
    sx: {
      img: {
        filter: whiteLogosFilter,
      },
    },
  },
};

export const opacity = "0.6";

export const getPriceStyleWithDiscount = (): {
  color: string;
  opacity: string;
  fontSize: string[];
} => {
  return {
    color: neutralColor0Hex,
    opacity,
    fontSize: ["14px"],
  };
};
